import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';


export interface AuthFormsState {
  showRegisterForm: boolean;
  showLoginForm: boolean;
  showForgetPasswordForm: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class AuthFormsService {

  // Keeping the shared state of
  //    auth-layout.component
  //    form.component
  //    register.component
  //    forgot-password.component
  private authFormsStateSubject = new BehaviorSubject<AuthFormsState>({
    showRegisterForm: false,
    showLoginForm: true,
    showForgetPasswordForm: false,
  });
  public authFormsStateObservable$ = this.authFormsStateSubject.asObservable()


  constructor(private router: Router) {
  }


  public isResetPwdForm(): boolean {
    const currentPath = this.router.url.split('?')[0]; // Strip query parameters
    return currentPath.includes('glomtLosenord') || currentPath.includes('nyttLosenord');
  }

  public showLoginForm() {    
    this.authFormsStateSubject.next({
      showLoginForm: true,
      showRegisterForm: false,
      showForgetPasswordForm: false,
    })
  }

  public showRegisterForm() {
    this.authFormsStateSubject.next({
      showLoginForm: false,
      showRegisterForm: true,
      showForgetPasswordForm: false,
    })
  }

  public getCurrentFormsState(): AuthFormsState {
    return this.authFormsStateSubject.value;
  }

  public showForgetPasswordForm() {
    this.authFormsStateSubject.next({
      showLoginForm: false,
      showRegisterForm: false,
      showForgetPasswordForm: true,
    })
  }
}
